var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.USER_PERMISSIONS === 'free')?_c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"advertisement-title"},[_vm._v("Advertisement")]),_c('Adsense',{attrs:{"ins-style":"","data-ad-client":_vm.client,"data-ad-slot":_vm.slot,"data-ad-format":"horizontal","data-full-width-responsive":"true"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }